const OFF = 0;
const SMS = 1;
const EMAIL = 2;

const state = () => ({
  twoFactorAuthorizationTypeId: OFF
});

const getters = {
  twoFactorAuthorizationTypeId(state) {
    return state.twoFactorAuthorizationTypeId;
  },
  isOff(state) {
    return state.twoFactorAuthorizationTypeId === OFF;
  },
  isSms(state) {
    return state.twoFactorAuthorizationTypeId === SMS;
  },
  isEmail(state) {
    return state.twoFactorAuthorizationTypeId === EMAIL;
  },
  apiTwoFactorAuthorizationTypeId(state) {
    return state.twoFactorAuthorizationTypeId === OFF ? null : state.twoFactorAuthorizationTypeId;
  }
};

const mutations = {
  setTwoFactorAuthorizationTypeId(state, value) {
    const parsedValue = Number(value);
    const validValues = [OFF, SMS, EMAIL];
    state.twoFactorAuthorizationTypeId = validValues.includes(parsedValue) ? parsedValue : OFF;
  },
  resetStore(s) {
    Object.assign(s, state());
  }
};

const actions = {
  setTwoFactorAuthorizationTypeId({ commit }, value) {
    commit('setTwoFactorAuthorizationTypeId', value);
  },
  hydrateFromAuth({ commit }, authUser) {
    const apiValue = authUser?.twoFactorAuthorizationTypeId;
    commit('setTwoFactorAuthorizationTypeId', apiValue === null ? OFF : Number(apiValue));
  },
  reset({ commit }) {
    commit('setTwoFactorAuthorizationTypeId', OFF);
  }
};

export const multifactor = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};

export const MFA_TYPES = { OFF, SMS, EMAIL };
